import React, { Fragment } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog } from '@fortawesome/free-solid-svg-icons'

const Loader = () => {
    return (
        <Fragment>
            <FontAwesomeIcon icon={faCog} spin />
        </Fragment>
    )
}
export default Loader;